<page-sidebar [page]="page" [sidebar]="sidebar" [index]="index" [editMode]="editMode" *ngFor="let sidebar of sidebars; let index = index"></page-sidebar>
<add-sidebar *ngIf="editMode" [page]="page"></add-sidebar>
